module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 32
// module chunks = 1 2 3 4 5 6 7 8 9